import { RankModel } from '../../ranking/models/rank.model';

export class TeamModel {

  /**
   * Constructor
   *
   * @param {string} iHash
   * @param {string} name
   * @param {RankModel} overall_rank
   */
  public constructor(
    public iHash: string = null,
    public name: string = null,
    public overall_rank: RankModel = new RankModel(),
  ) { }
}
